interface IHighlightTextProps {
  text: string;
  search: string;
}

export default function HighlightText({ text, search }: IHighlightTextProps) {
  if (!search) return text;

  const lowerText = text.toLowerCase();
  const lowerSearch = search.toLowerCase();

  const parts = [];
  let startIndex = 0;
  let matchIndex;

  while ((matchIndex = lowerText.indexOf(lowerSearch, startIndex)) !== -1) {
    // eşleşmeden önceki kısım
    if (matchIndex > startIndex) {
      parts.push(text.slice(startIndex, matchIndex));
    }

    // eşleşen kısmı bold yap
    parts.push(
      <span className="font-700" key={matchIndex}>
        {text.slice(matchIndex, matchIndex + search.length)}
      </span>
    );

    startIndex = matchIndex + search.length;
  }

  // kalan kısmı ekle
  if (startIndex < text.length) {
    parts.push(text.slice(startIndex));
  }

  return parts;
}

